import { baseApi, transformErrorResponse } from '@ibk/shared-config';
export const pixFavoredContactApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        getFavoredContacts: builder.query({
            query: () => ({
                url: '/v1/accounts/favored-contacts?detailsType=1',
                forceSelectedAccountInfoAccountId: true,
                forceAccountantApiBaseUrl: true,
            }),
            transformErrorResponse,
        }),
        getFavoredBankContacts: builder.query({
            query: () => ({
                url: '/v1/accounts/favored-contacts?detailsType=2',
                forceSelectedAccountInfoAccountId: true,
                forceAccountantApiBaseUrl: true,
            }),
            transformErrorResponse,
        }),
        starFavoredContact: builder.mutation({
            query: ({ contactId }) => ({
                url: `/v1/favored-contacts/${contactId}/star`,
                method: 'POST',
                forceSelectedAccountInfoAccountId: true,
                forceAccountantApiBaseUrl: true,
            }),
            transformErrorResponse,
        }),
        unstarFavoredContact: builder.mutation({
            query: ({ contactId }) => ({
                url: `/v1/favored-contacts/${contactId}/unstar`,
                method: 'POST',
                forceSelectedAccountInfoAccountId: true,
                forceAccountantApiBaseUrl: true,
            }),
            transformErrorResponse,
        }),
        deleteFavoredContact: builder.mutation({
            query: ({ contactId }) => ({
                url: `/v1/favored-contacts/${contactId}`,
                method: 'DELETE',
                forceSelectedAccountInfoAccountId: true,
                forceAccountantApiBaseUrl: true,
            }),
            transformErrorResponse,
        }),
        postCreateFavoredContact: builder.mutation({
            query: body => ({
                url: `/v1/favored-contacts`,
                method: 'POST',
                body,
                forceSelectedAccountInfoAccountId: true,
                forceAccountantApiBaseUrl: true,
            }),
            transformErrorResponse,
        }),
    }),
});
export const { useLazyGetFavoredContactsQuery, useLazyGetFavoredBankContactsQuery, useStarFavoredContactMutation, useUnstarFavoredContactMutation, useDeleteFavoredContactMutation, usePostCreateFavoredContactMutation, } = pixFavoredContactApi;
